import {Behavior} from './ToggleArea';
import fd, {measure, mutate} from './promise-fastdom';
import promiseRAF from "./promise-raf";

const _ = new WeakMap();

export function SizeTransitionBehavior(dims = ['height']) {
    _.set(this, {
        dims: dims,
        rect: null,
        instance: null,
    });
}

SizeTransitionBehavior.prototype = new Behavior();

SizeTransitionBehavior.prototype.beforeOpen = function (instance) {
    const o = _.get(this);
    return Promise.resolve()
        .then(measure(() => {
            instance.area().hidden = false;
            o.rect = {
                width: instance.area().offsetWidth,
                height: instance.area().offsetHeight,
            };

            // chrome bug workaround
            instance.area().style.transition = 'none';

            o.dims.forEach(dim => instance.area().style[dim] = 0);
            instance.area().hidden = true;
        }))
        .then(promiseRAF())
        .then(mutate(() => {
            // chrome bug workaround
            instance.area().style.removeProperty('transition');
        }));
};

SizeTransitionBehavior.prototype.startOpen = function (instance) {
    const o = _.get(this);
    return fd.mutate(() => {
        o.dims.forEach(dim => instance.area().style[dim] = o.rect[dim] + 'px');
    });
};

SizeTransitionBehavior.prototype.afterOpen = function (instance) {
    const o = _.get(this);
    return fd.mutate(() => {
        o.dims.forEach(dim => instance.area().style.removeProperty(dim));
    });
};

SizeTransitionBehavior.prototype.beforeClose = function (instance) {
    const o = _.get(this);
    return Promise.resolve()
        .then(measure(() => {
            o.rect = {
                width: instance.area().offsetWidth,
                height: instance.area().offsetHeight,
            };
        }))
        .then(mutate(() => {

            // chrome bug workaround
            instance.area().style.transition = 'none';

            o.dims.forEach(dim => instance.area().style[dim] = o.rect[dim] + 'px');
        }))
        .then(promiseRAF())
        .then(mutate(() => {
            // chrome bug workaround
            instance.area().style.removeProperty('transition');
        }));
};

SizeTransitionBehavior.prototype.startClose = function (instance) {
    const o = _.get(this);
    return fd.mutate(() => {
        o.dims.forEach(dim => instance.area().style[dim] = 0);
    });
};

SizeTransitionBehavior.prototype.afterClose = function (instance) {
    const o = _.get(this);
    return fd.mutate(() => {
        o.dims.forEach(dim => instance.area().style.removeProperty(dim));
    });
};

SizeTransitionBehavior.prototype.destroy = function (instance) {
    const o = _.get(this);
    return fd.mutate(() => {
        o.dims.forEach(dim => instance.area().style.removeProperty(dim));
    });
};
